module.exports = __webpack_public_path__ + "img/icon_notif_unread_mobile.1b9498a1.svg";